var config = {
  env: {
    FS_DEBUG: (window.FS_ENV.ENVIRONMENT === 'development'),
    FS_API_HOST: '/api/v7',
    FS_APP_VERSION: '5.1',
  }
}

export default config;
